import { PlacementOnCanvas } from '../canvas/placement-on-canvas';

export class ContentControlledKeyframe implements PlacementOnCanvas {
  constructor(
    public timeInMs: number = 0,
    public x: number = 0,
    public y: number = 0,
    public width: number = 100,
    public height: number = 100,
    public isTween: boolean = false,
  ) {}
  public clone() {
    return new ContentControlledKeyframe(
      this.timeInMs,
      this.x,
      this.y,
      this.width,
      this.height,
      this.isTween,
    );
  }
  public sameTime(to: ContentControlledKeyframe) {
    return this.timeInMs == to.timeInMs;
  }
  public equal(to: ContentControlledKeyframe) {
    return (
      this.x === to.x &&
      this.y === to.y &&
      this.width === to.width &&
      this.height === to.height &&
      this.timeInMs === to.timeInMs
    );
  }
  public ingest(poc: ContentControlledKeyframe | PlacementOnCanvas) {
    this.x = Math.abs(poc.x);
    this.y = Math.abs(poc.y);
    this.width = Math.abs(poc.width);
    this.height = Math.abs(poc.height);
  }
  public exportPlacement(): PlacementOnCanvas {
    return new PlacementOnCanvas(
      this.x,
      this.y,
      this.width,
      this.height,
    );
  }
  interpolatePlacementOnCanvas(
    endKeyframe: ContentControlledKeyframe,
    t: number,
  ): PlacementOnCanvas {
    return new PlacementOnCanvas(
      this.x + (endKeyframe.x - this.x) * t,
      this.y + (endKeyframe.y - this.y) * t,
      this.width + (endKeyframe.width - this.width) * t,
      this.height + (endKeyframe.height - this.height) * t,
    );
  }
}
